import { network } from 'services/network';
import { useQuery } from 'react-query';
import { QueryKeys } from 'api/queryKeys';
import { IFilter } from 'components/Dashboards/Project/Components/CustomDashboard/utils/utils.type';
import { IPhasePerformanceContracts } from 'components/Dashboards/Portfolio/phasePerformance/phasePerformance.types';

const queryFn = (params: QueryParams) => {
    const url = 'api/bo/phaseperformance/getMappedContracts';
    return network.post(url, { template_id: params.templateId, filter: params.filter }).then((response) => {
        return response.data;
    });
};

export const useQueryPhasePerformanceGetContracts = (params: QueryParams) => {
    return useQuery<QueryFnResponse, QueryError, QueryResponse, [QueryKeys, unknown]>({
        queryKey: ['getMappedContracts', params],
        queryFn: () => queryFn(params),
        enabled: Boolean(params.templateId),
    });
};

interface QueryParams {
    templateId?: number;
    filter: {
        filters: IFilter[];
    };
}

export interface QueryFnResponse {
    mapped_contracts: IPhasePerformanceContracts[];
    phase_performance_breakdown_info: IToolTip;
    phase_performance_chart_info: IToolTip;
}

type QueryResponse = QueryFnResponse & {};
